import React from "react";

const SymposiumMenulisIlmiah: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Kemampuan menulis karya ilmiah menjadi salah satu keterampilan penting di era pendidikan modern, terutama seiring meningkatnya tuntutan akademik dan kebutuhan akan pemahaman riset yang komprehensif. Berbagai forum ilmiah pelajar dan mahasiswa turut berperan dalam menumbuhkan budaya riset, seperti{" "}
        <a
          href="https://lomba.brin.go.id/lkir"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          LKIR (Lomba Karya Ilmiah Remaja)
        </a>{" "}
        serta forum diskusi dan simposium akademik berskala nasional maupun regional yang menekankan kualitas penulisan ilmiah dan metodologi penelitian.
      </p>

      <p>
        Dalam konteks tersebut, <strong>Student Symposium Research Paper</strong>{" "}
        dirancang untuk membantu peserta memahami proses penulisan ilmiah secara menyeluruh, mulai dari perumusan ide, penyusunan kerangka tulisan, hingga penyajian hasil penelitian secara objektif dan sistematis. Melalui kegiatan ini, peserta dilatih mengolah informasi, menelaah sumber ilmiah secara kritis, serta menyampaikan gagasan akademik secara terstruktur sebagai bekal penting untuk jenjang pendidikan dan dunia profesional di masa depan.
      </p>

      <p>
        Peserta dilatih untuk menyampaikan gagasan secara jelas melalui penggunaan bahasa akademik yang tepat dan mudah dipahami. Setiap argumen yang disampaikan harus memiliki dasar yang kuat, sehingga peserta belajar mempertanggungjawabkan pemikirannya secara logis dan ilmiah. Pendekatan serupa juga diterapkan dalam berbagai kegiatan akademik lain yang berfokus pada pengembangan literasi riset. Proses revisi dan evaluasi menjadi bagian penting dalam meningkatkan kualitas tulisan, sehingga peserta terbiasa menyesuaikan struktur dan format sesuai kaidah penulisan ilmiah yang berlaku secara luas.
      </p>

      <p>
        Relevansi kemampuan riset dan penulisan ilmiah juga tercermin dari berbagai capaian akademik terbaru.{" "}
        <a
          href="https://inhum.vokasi.undip.ac.id/en/undip-information-and-public-relations-research-team-wins-gold-medal-at-the-international-science-and-invention-fair-isif-2025/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline"
        >
          Tim mahasiswa Universitas Diponegoro
        </a>{" "}
        , misalnya, berhasil meraih medali emas pada <em>International Science and Invention Fair (ISIF) 2025</em>, sebuah ajang riset internasional yang diikuti peserta dari berbagai negara. Prestasi ini menunjukkan bahwa kemampuan menyusun karya ilmiah berbasis riset yang kuat menjadi modal penting untuk bersaing di tingkat global.
      </p>

      <p>
        Melalui Kompetisi IIT, <strong>Student Symposium Research Paper</strong>{" "}
        menjadi sarana pembinaan yang efektif dan berkelanjutan bagi peserta dalam mengembangkan keterampilan riset dan penulisan ilmiah. Dibandingkan dengan berbagai forum akademik sejenis, IIT menekankan keseimbangan antara proses pembelajaran dan penguatan karakter akademik peserta. Program ini tidak hanya berfokus pada hasil akhir berupa karya tulis, tetapi juga membangun kepercayaan diri, kemampuan menyusun serta mempresentasikan ide, dan kesiapan menghadapi tantangan akademik di jenjang pendidikan yang lebih tinggi.
      </p>

      <p>
        👉{" "}
        <a
          href="/iit-program?program=Symposium"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Cek untuk informasi Student Symposium Research Paper lebih lanjut
        </a>
      </p>
    </div>
  );
};

export default SymposiumMenulisIlmiah;
